<template>
<div class="askBank" >
 <hd-com></hd-com>
  <div class="chat-page">
    <!-- 顶部导航 -->
    <div class="page-header">
      <div class="back-btn" @click="$router.back()">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="header-title">智能问答</div>
      <div class="header-empty"></div>
    </div>

    <div class="chat-box" ref="messagesWrap">
      <!-- 欢迎助手消息 -->
      <div class="msg-row robot-row" >
        <div class="robot-card" style="position: relative;">
          <div class="robot-top">
            <div class="robot-text">
              <!-- <div class="hi-text">Hi</div>
              <div class="desc-text">我是您的智能问诊助手</div> -->
              <img src="../../assets/img/aiHello.png"  style="width: 200px;height: 57px;" alt="" srcset="">
              <div class="tip-text" style="margin-top: 15px;">我可以帮助您了解疾病症状、药品使用等相关信息。请描述您的不适。</div>
            </div>
            <div class="robot-icon">
              <img src="../../assets/img/aiHello2.png" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>

      <!-- 对话消息列表 -->
      <div v-for="(item, index) in msgList" :key="index" class="msg-row" :class="item.type === 'user' ? 'user-row' : 'robot-row'">
        <!-- 用户消息 -->
        <div v-if="item.type === 'user'"  class="user-bubble-wrap">
            <div class="user-bubble">
                {{ item.content }}
            </div>
            <div class="time-small">{{ item.time }}</div>
        </div>
        <!-- 机器人回复消息 -->
         <div v-else class="robot-wrap">
        <div  class="robot-card" style="padding-right: 19px;">
          <!-- loading状态 -->
          <div v-if="item.isLoading" class="loading-indicator">
            <div class="loading-dots">
              <span></span><span></span><span></span>
            </div>
            正在思考...
          </div>
          <div v-else class="reply-content">
            <p>{{ item.beforeCardText }}</p>
            <!-- 症状选项按钮组 -->
            <div v-if="item.optionList && item.optionList.length" class="option-group">
              <div v-for="(opt, idx) in item.optionList" :key="idx" class="option-btn" @click="clickOption(opt)">
                <div style="display: flex;align-items: baseline;">
                    <img src="../../assets/img/ail3.png" style="width: 18px;height: 18px;" alt=""> 
                    <div style="margin-left: 7px;">
                        <div style="font-weight: bold;font-size: 16px;color: #FFFFFF;">{{ opt.title }}</div>
                        <div class="opt-sub">{{ opt.sub }}</div>
                    </div>
                </div>
                <img src="../../assets/img/ail4.png" style="width: 18px;height: 18px;" alt="">
              </div>
            </div>
            <div v-if="item.intent == 'drug_interaction_query'" style=" background: linear-gradient(90deg, #4284DB, #29EAC4);color: #fff;padding: 11px 15px;padding-right: 17px;border-radius: 10px;cursor: pointer;text-align: center;margin-bottom: 10px;"  @click="clickPeiwu(item)">
               查看配伍详情
            </div>
             <p v-if="item.afterCardText" class="after-card-text">{{ item.afterCardText }}</p>

            <!-- 底部提示 -->
            <div v-if="item.bottomTip" class="bottom-tip">{{ item.bottomTip }}</div>
            <!-- 后续快捷问题 -->
            <div v-if="item.quickList && item.quickList.length" class="quick-question-group">
              <div v-for="(q, qIdx) in item.quickList" :key="qIdx" class="quick-question" @click="sendMsg(q)">
                {{ q }}
              </div>
            </div>
          </div>
        </div>
        <div class="time-label robot-time">{{ item.time }}</div>
      </div>
    </div>
    </div>
    <!-- 底部输入框区域 -->
    <!-- <div class="input-bottom">
    <input
        v-model="inputText"
        placeholder="请输入问题"
        class="chat-input"
        @keyup.enter="sendMsg(inputText.trim())"
    />
    <div class="send-btn" @click="sendMsg(inputText.trim())">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
    </div>
    </div> -->
    <div class="input-bottom">
  <textarea
    v-model="inputText"
    placeholder="请输入问题"
    class="chat-input"
    @keyup.enter="handleEnter($event)"
  ></textarea>
  <div class="send-btn" @click="sendMsg(inputText.trim())">
    <img src="../../assets/img/aiHelloSend.png" alt="" srcset="">
    <!-- <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
    </svg> -->
  </div>
</div>
  </div>
     <UpgradeMsgBox ref="upgradeMsgBox" @currentlyAvailable="getCurrentlyAvailable" :fullPath="$router.currentRoute.fullPath"></UpgradeMsgBox>

  </div>
</template>

<script>
import hdCom from "../../components/header"; //引入组件
import { addCompare, getCompatibilityList } from "../../utils/Compatibility";
export default {
    components: {
    hdCom
  },
  name: 'ChatAsk',
  data() {
    return {
      inputText: '',
      sessionId: '', // 预先定义
      asstoken: "",
      ChathubAgents:'',
      currentlyAvailable: false,
      // 对话消息数据
      msgList:[],
    //   msgList: [
    //     {
    //       type: 'user',
    //       content: '最近血压有点高',
    //       time: '11:22'
    //     },
    //     {
    //       type: 'robot',
    //       time: '11:22',
    //       content: '血压升高可能无明显症状，但部分人可出现头痛、头晕、耳鸣、视力模糊或心悸等表现。长期未控制的高血压会增加心脑血管疾病风险，如脑卒中、心肌梗死等。',
    //       optionList: [
    //         { title: '血压升高', sub: '心血管系统/血压异常' },
    //         { title: '血压降低', sub: '心血管系统/血压异常' },
    //         { title: '颈静脉怒张颈静脉怒张颈静脉怒张', sub: '心血管系统/体征' },
    //         { title: '发绀', sub: '呼吸循环系统外观表现' },
    //         { title: '跨越步态', sub: '呼吸循环系统外观表现' }
    //       ],
    //       bottomTip: '建议您及时测量血压并记录数值，若持续高于140/90 mmHg，应尽早就医评估，明确原因并制定管理方案。\n————————————————————\n如有其他问题，请随时提问。',
    //       quickList: [
    //         '血压有哪些常见症状?',
    //         '血压高该如何治疗?',
    //         '血压高可能引发哪些疾病?'
    //       ],
    //       isLoading: false
    //     },
    //     {
    //       type: 'user',
    //       content: '最近血压有点高',
    //       time: '11:22'
    //     }
    //   ],
      marked: null
    }
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + this.asstoken,
      };
    },
  },
  async mounted() {
    // 修复1：判断marked是否存在再配置，防止undefined调用setOptions
    if (window.marked) {
      this.marked = window.marked
      this.marked.setOptions({
        breaks: true,
        gfm: true,
        code: (code, language) => {
          const lang = language || 'plaintext'
          return `<pre class="code-block"><code class="language-${lang}">${this.escapeHtml(code)}</code></pre>`
        }
      })
    }

    // 初始化sessionId，统一sessionStorage
    this.ChathubAgents = this.Services.ChathubAgents,
    console.log(this.Services.ChathubAgents)
    this.asstoken = await this.TokenClient.AccessToken();
    this.initSessionId()
    this.scrollBottom()
  },
  methods: {
    clickPeiwu(opt){
      console.log(opt)
      var compatibility = getCompatibilityList();
          opt.optionList.forEach((res)=>{
             let isExist = false;
            if (compatibility.length > 0) {
              isExist = compatibility.some(item => item.hashKey === res.hashKey);
            }
            if (!isExist) {
              addCompare(res.id, res.title, 1, res.knowledgeType);
            }
          })
          const href = this.$router.resolve({
            path: "/Compatibility",
          });
          window.open(href.href, "_blank");
    },
    getCurrentlyAvailable(data) {
      this.currentlyAvailable = data;
    },
    scrollBottom() {
      this.$nextTick(() => {
        const chatWrap = document.querySelector('.chat-box')
        if (chatWrap) {
          chatWrap.scrollTop = chatWrap.scrollHeight
        }
      })
    },
    // 生成sessionId 完全复刻chat.js
    generateSessionId() {
      return 'sess_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
    },
    // 修复2：统一使用sessionStorage，不再混用localStorage
    initSessionId() {
      let cacheId = sessionStorage.getItem('chatSessionId')
      if (!cacheId) {
        cacheId = this.generateSessionId()
        sessionStorage.setItem('chatSessionId', cacheId)
      }
      // 强制赋值，保证一定有值
      this.sessionId = cacheId
      console.log('当前sessionId', this.sessionId) // 打印校验
    },
    // HTML转义
    escapeHtml(text) {
      if (!text) return ''
      const div = document.createElement('div')
      div.textContent = text
      return div.innerHTML
    },
    // 获取时分时间
    getNowTime() {
      const date = new Date()
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      return `${h}:${m}`
    },
    // 发送消息入口
    sendMsg(text) {
      console.log(this.currentlyAvailable)
      if (!this.currentlyAvailable) {
        this.$refs.upgradeMsgBox.openTip();
        return;
      }
      const val = text.trim()
      if (!val) return
      // 防御：sessionId为空直接重置会话
      if (!this.sessionId) {
        this.initSessionId()
      }
      this.inputText = ''
      const nowTime = this.getNowTime()
      // 插入用户消息
      this.msgList.push({
        type: 'user',
        content: val,
        time: nowTime
      })
      this.scrollBottom()
      // 插入loading机器人消息
      const loadingIndex = this.msgList.push({
        type: 'robot',
        content: '',
        time: nowTime,
        isLoading: true,
        optionList: [],
        bottomTip: '',
        quickList: []
      }) - 1
      // 发起SSE请求
      this.sendRealRequest(val, loadingIndex)
    },
    // 点击症状选项
    clickOption(item) {
        if (item.knowledgeType == 'disease') {
            const href = this.$router.resolve({
              path: "/disease/DiseaseDetail",
              query: {
                hashKey: item.id,
                searchType: "disease",
              },
            });
            window.open(href.href, "_blank");
        }
        if (item.knowledgeType == 'drug') {
            const href = this.$router.resolve({
              path: "/Drug/DrugDetail",
              query: {
                hashKey: item.id,
                searchType: "drug",
              },
            });
            window.open(href.href, "_blank");
        }
        if (item.knowledgeType == 'symptom') {
            const href = this.$router.resolve({
              path: "/Drug/symptomDetail",
              query: {
                hashKey: item.id,
                searchType: "symptom",
              },
            });
            window.open(href.href, "_blank");
        }

      // this.sendMsg(item.title)
    },
    // 更新机器人消息内容（适配模板字段）
    updateMessage(index, text, opt = {}) {
      console.log(this.msgList[index])
        const item = this.msgList[index]
        if (!item) return
        item.isLoading = false

        // 分割[[card]]前后两段文字
        const splitArr = text.split('[[card]]')
        item.beforeCardText = splitArr[0] || ''
        item.afterCardText = splitArr[1] || ''
        item.intent = opt.intent
        // 后端cards映射为页面option按钮
        if (opt.cards && opt.cards.length) {
          console.log(opt)
          console.log('----------------------------')
            item.optionList = opt.cards.map(card => ({
            title: card.title,
            sub: card.category,
            id:card.id,
            knowledgeType:card.type
            }))
        } else {
            item.optionList = []
        }

        item.quickList = opt.suggestions || []
        item.bottomTip = opt.closingText || ''
        this.scrollBottom()
    },
    // SSE核心请求解析（修复JSON报错、字段适配模板）
    async sendRealRequest(message, loadingMsgIndex) {
      const reqBody = {
        message: message,
        sessionId: this.sessionId
      }
      console.log(this.ChathubAgents)
      try {
        const response = await fetch(this.ChathubAgents, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.asstoken}` // 标准鉴权头，后端通用格式
          },
          body: JSON.stringify(reqBody)
        })
        console.log(response)
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''
        let fullText = ''
        let cards = []
        let suggestions = []
        let closingText = ''
        let tokens = { input: 0, output: 0 }
        let currentIntent = null

        while (true) {
          const { done, value } = await reader.read()
          if (done) break
          buffer += decoder.decode(value, { stream: true })
          // 双换行分割SSE块
          const chunks = buffer.split('\n\n')
          buffer = chunks.pop() || ''

          for (const chunk of chunks) {
            if (!chunk.trim()) continue
            // 剥离data:前缀
            let jsonRaw = chunk.replace(/^data:\s*/, '').trim()
            if (!jsonRaw) continue

            try {
              const data = JSON.parse(jsonRaw)
              console.log(data)
              if (data.Type === 'text') {
                fullText += data.Content || ''
                // 实时刷新文本
                this.updateMessage(loadingMsgIndex, fullText, {
                  cards, intent: currentIntent, suggestions, closingText, tokens
                })
              } else if (data.Type === 'card') {
                cards.push({
                  id: data.Id,
                  type: data.KnowledgeType,
                  title: data.Title,
                  alias: data.Alias || '',
                  category: data.Category || '',
                  symptom: data.Symptom || '',
                  desc: data.Description || ''
                })
              } else if (data.Type === 'intent') {
                currentIntent = data.Intent
              } else if (data.Type === 'suggestion') {
                suggestions = data.Questions || []
              } else if (data.Type === 'done') {
                tokens = {
                  input: data.Usage?.InputTokenCount || 0,
                  output: data.Usage?.OutputTokenCount || 0
                }
                closingText = data.ClosingText || ''
              }
            } catch (parseErr) {
                console.log(parseErr)
              console.error('单条SSE JSON解析失败', {
                原始chunk: chunk,
                剥离json: jsonRaw,
                错误: parseErr
              })
            }
          }
        }
        // 流结束最终渲染
        this.updateMessage(loadingMsgIndex, fullText, {
          cards, intent: currentIntent, suggestions, closingText, tokens
        })
      } catch (err) {
        console.error('对话接口异常', err)
        console.error('完整错误堆栈', err.stack)
        const targetMsg = this.msgList[loadingMsgIndex]
        targetMsg.isLoading = false
        targetMsg.content = `抱歉，发生了错误：${err.message}。请稍后重试。`
        targetMsg.optionList = []
        targetMsg.quickList = []
        targetMsg.bottomTip = ''
        this.scrollBottom()
      }
    },
    // 重置会话
    resetSession() {
      sessionStorage.removeItem('chatSessionId')
      this.sessionId = this.generateSessionId()
      sessionStorage.setItem('chatSessionId', this.sessionId)
      this.msgList = []
    }
  }
}
</script>

<style scoped>
.askBank {
   background-color: #f5f7fa;
}
.chat-page {
  width: 50%;
  margin-left: 25%;
  height: 90vh;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 20px;
}
/* 顶部导航 */
.page-header {
  flex-shrink: 0; /* 头部固定高度，不压缩 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.back-btn {
  color: #666;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.header-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}
.header-empty {
  width: 60px;
}

/* 聊天主体区域 */
.chat-box {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
   /* 关键：高度自适应挤压，不会撑开页面 */
  display: flex;
  flex-direction: column;
  gap:24px;
}
.msg-row {
  margin-bottom: 0px;
  display: flex;
  flex-shrink: 0; /* 消息条目不压缩 */
}
.user-row {
  justify-content: flex-end;
}
.robot-row {
  justify-content: flex-start;
}

/* 机器人欢迎卡片 */
.robot-card {
  max-width: 680px;
  background: #ebf4ff;
  border-radius: 12px;
  padding: 30px 19px;
  padding-right: 120px;
}
.robot-top {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.robot-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink:0;
}
.hi-text {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}
.desc-text {
  font-size: 15px;
  color: #333;
  margin-bottom: 6px;
}
.tip-text {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
.robot-icon {
  width: 110px;
  height: 110px;
  position: absolute;
  top: -17px;
  right:43px;
}
.robot-icon img {
    width: 100%;
    height: 100%;
}
.time-label {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
.user-row {
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.user-bubble-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.user-bubble {
  /* background: linear-gradient(90deg,#409EFF,#36d1e8); */
  background: linear-gradient(-30deg, #52DEEF, #3B79F7);

  color: #fff;
  padding: 10px 14px;
  border-radius: 12px 12px 2px 12px;
  max-width: 100%;
}
.time-small {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}

/* 回复内容 */
.reply-content p {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0 0 12px 0;
}
/* 选项按钮组 */
.option-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.option-btn {
  /* background: linear-gradient(90deg, #409EFF, #36d1b3); */
  background: linear-gradient(90deg, #4284DB, #29EAC4);
  color: #fff;
  padding: 11px 15px;
  padding-right: 17px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.opt-sub {
  font-size: 12px;
    color: #FFFFFF;
    font-style: italic;
    opacity: 0.8;
}
/* 底部提示文字 */
.bottom-tip {
  font-size: 13px;
  color: #555;
  line-height: 1.5;
  padding-top: 10px;
  border-top: 1px dashed #ccd9eb;
  margin-bottom: 12px;
}
/* 快捷问题按钮 */
.quick-question-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.quick-question {
  background: #fff;
  border: 1px solid #dceaff;
  border-radius: 18px;
  padding: 6px 12px;
  font-size: 13px;
  color: #666666;
  cursor: pointer;
  width: fit-content;
}

/* loading动画 */
.loading-indicator {
  display: flex;
  align-items: center;
  gap:8px;
  padding:10px 0;
}
.loading-dots span {
  display:inline-block;
  width:8px;
  height:8px;
  border-radius:50%;
  background:#409EFF;
  margin:0 2px;
  animation: dot 1.4s infinite ease-in-out both;
}
.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }
@keyframes dot {
  0%,80%,100% { transform: scale(0); }
  40% { transform: scale(1); }
}

/* 底部输入栏 */
.input-bottom {
  flex-shrink: 0;
  margin:0 20px 20px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 16px 20px;
  background: #f0f7ff;
  border-radius: 16px;
  border: 1px solid #e1ecff;
}
.chat-input {
  flex: 1;
  min-height: 80px;
  max-height: 120px; /* 限制最大高度，防止无限拉高 */
  background: transparent;
  border: none;
  font-size: 16px;
  outline: none;
  color:#333;
  resize: none; /* 关闭原生拖动缩放 */
  line-height: 1.5;
  padding: 8px 0;
}
.chat-input::placeholder {
  color:#b4c3e0;
}
.send-btn {
  width: 36px;
  height: 36px;
  /* border-radius: 50%;
  background: linear-gradient(90deg,#409EFF,#36d1e8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink:0; */
}
.send-btn img {
  width: 100%;
  height: 100%;
}
</style>